"use client";

import { updateHost } from "./features/generalSlice";
import { store } from "./store";
import { Provider } from "react-redux";

export function Providers({
  children,
  host,
}: {
  children: React.ReactNode;
  host: string;
}) {
  store.dispatch(
    updateHost(host === "localhost:3000" ? "successagency" : host)
  );
  return <Provider store={store}>{children}</Provider>;
}
